import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { identity, pickBy } from 'lodash';

import { API_URL } from '../../../common/constants/api-url';
import { PagesFilterState } from '../../reducers/pages/pages-filter';
import { getBaseQuery } from '../base-query';
import { PagesExportTransformedBody } from './data-exports-api-types';

export const dataExportsApiSlice = createApi({
  baseQuery: getBaseQuery({
    baseUrl: `${API_URL}/admin/download`,
  }),
  endpoints: (builder) => ({
    getPagesExport: builder.query<PagesExportTransformedBody, PagesFilterState>({
      query: (params) => ({
        method: 'GET',
        params: {
          limit: 20,
          offset: 0,
          ...pickBy(params, identity()),
        },
        responseHandler: 'text',
        url: '/agg-pages',
      }),
      transformResponse: (data: string, meta) => {
        const contentDisposition = meta?.response?.headers.get('content-disposition');
        let fileName = 'pages_data.csv';
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="(.*)"/);
          if (match && match[1]) {
            fileName = match[1];
          }
        }
        return {
          data,
          fileName,
        };
      },
    }),
  }),
  reducerPath: 'dataExports',
});
